/**
 * Public sales sites of the B2B systems, which live on their own subdomains.
 *
 * The consumer app links straight to them instead of relying on the legacy
 * `/sistema-arenas` and `/sistema-professores` routes: those stay only as a
 * client-side redirect for links already shared or indexed out there.
 *
 * Env-driven so dev links to the dev subdomains — hardcoding production URLs
 * would send someone testing in dev to the live site.
 */
export const B2B_SITES = {
  arenas: import.meta.env.VITE_ARENAS_SITE_URL || 'https://arenas.meiucaapp.com.br',
  trainingCenters: import.meta.env.VITE_CT_SITE_URL || 'https://ct.meiucaapp.com.br',
} as const
